import Grid from "@mui/material/Grid2";
import CustomTextField from "../custom-text-field/CustomTextField";
import {
  FORM_LABEL_DESCRIPTION,
  FORM_LABEL_NAME,
  FORM_PLACEHOLDER_MILESTONE_DESCRIPTION,
  FORM_PLACEHOLDER_TEXTFIELD,
} from "../../utility/constants/locale";
import { Typography } from "@mui/material";
import { useEffect, useState } from "react";

interface MultiLanguageFormProps {
  language: string;
  onChange: (values: { name: string; description: string }) => void;
  name?: string;
  description?: string;
}

const MultiLanguageForm: React.FC<MultiLanguageFormProps> = ({
  language,
  onChange,
  name = "",
  description = "",
}) => {
  const [localName, setLocalName] = useState(name);
  const [localDescription, setLocalDescription] = useState(description);

  useEffect(() => {
    setLocalName(name);
    setLocalDescription(description);
  }, [name, description]);

  const handleInputChange = (field: "name" | "description", value: string) => {
    let updatedName = localName;
    let updatedDescription = localDescription;

    if (field === "name") {
      updatedName = value;
      if (value === "") updatedDescription = "";
    } else if (field === "description") {
      updatedDescription = value;
    }

    setLocalName(updatedName);
    setLocalDescription(updatedDescription);

    onChange({ name: updatedName, description: updatedDescription });
  };

  return (
    <Grid
      container
      spacing={1}
      mb={3}
      alignItems={"center"}
    >
      <Grid size={1}>
        <Typography
          variant="h3"
          sx={{ fontWeight: "500", lineHeight: "18.75px", marginTop: "15px" }}
        >
          {language}
        </Typography>
      </Grid>
      <Grid size={4}>
        <CustomTextField
          placeholder={FORM_PLACEHOLDER_TEXTFIELD}
          inputFormTitle={FORM_LABEL_NAME}
          value={localName}
          changeTrigger={(value) => handleInputChange("name", value)}
          maxLength={64}
        />
      </Grid>
      <Grid size={7}>
        <CustomTextField
          placeholder={FORM_PLACEHOLDER_MILESTONE_DESCRIPTION}
          inputFormTitle={FORM_LABEL_DESCRIPTION}
          value={localDescription}
          changeTrigger={(value) => handleInputChange("description", value)}
          maxLength={512}
          disabled={!localName}
        />
      </Grid>
    </Grid>
  );
};

export default MultiLanguageForm;
